












































import { Component, Mixins } from "vue-property-decorator";
import { FeedbackFormService } from "../../service/feedback-form.service";
import CommonMixin from "@/mixins/common-mixins";
import { FeedbackRaffleContent } from '@/models/content/feedback-raffle';
import { ContentService } from "@/service/content.service"

@Component({
  components: {},
})
export default class FeedbackRaffle extends Mixins(CommonMixin) {
  feedbackFormService = new FeedbackFormService();
  contentService = new ContentService();
  content: FeedbackRaffleContent = {} as FeedbackRaffleContent;
  hrefData = "";
  feedbackFormLoaded = false;
  haveBadToken = false;

  async mounted(): Promise<void> {
    try {
      this.content = await this.contentService.getFeedbackRaffleContent();
      const token = this.$route.params.token;
      const secure = await this.feedbackFormService.getFeedbackRaffle(token);
      this.hrefData = `data:application/octet-stream,${secure.csv}`;
      this.feedbackFormLoaded = true;
    } catch (error) {
      if (error.response.status === 422) {
        this.haveBadToken = true;
      }
    }
  }
}
